const MOCK_DELAY = 700;

function simulateAsync(data, error = null, delay = MOCK_DELAY) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            if (error) reject(new Error(error));
            else resolve(data);
        }, delay);
    });
}

const quizData = {};

const mockQuiz = {
    "title": "General Knowledge Quiz",
    "description": "A demo quiz with 10 multiple choice questions covering various topics",
    "questions": [
        {
            "id": 1,
            "question": "What is the capital of France?",
            "options": [
                "London",
                "Berlin",
                "Paris",
                "Madrid"
            ],
            "correct_answer": [3],
            "explanation": "Paris is the capital and largest city of France."
        },
        {
            "id": 2,
            "question": "Which planet is known as the Red Planet?",
            "options": [
                "Venus",
                "Mars",
                "Jupiter",
                "Saturn"
            ],
            "correct_answer": [2],
            "explanation": "Mars is called the Red Planet due to its reddish appearance caused by iron oxide on its surface."
        },
        {
            "id": 3,
            "question": "What is the largest mammal in the world?",
            "options": [
                "African Elephant",
                "Blue Whale",
                "Giraffe",
                "Polar Bear"
            ],
            "correct_answer": [2],
            "explanation": "The Blue Whale is the largest animal ever known to have lived on Earth."
        },
        {
            "id": 4,
            "question": "In which year did World War II end?",
            "options": [
                "1944",
                "1945",
                "1946",
                "1947"
            ],
            "correct_answer": [2],
            "explanation": "World War II ended in 1945 with the surrender of Japan in September."
        },
        {
            "id": 5,
            "question": "What is the chemical symbol for gold?",
            "options": [
                "Go",
                "Gd",
                "Au",
                "Ag"
            ],
            "correct_answer": [3],
            "explanation": "Au is the chemical symbol for gold, derived from the Latin word 'aurum'."
        },
        {
            "id": 6,
            "question": "Which ocean is the largest?",
            "options": [
                "Atlantic Ocean",
                "Indian Ocean",
                "Arctic Ocean",
                "Pacific Ocean"
            ],
            "correct_answer": [4],
            "explanation": "The Pacific Ocean is the largest ocean, covering about one-third of Earth's surface."
        },
        {
            "id": 7,
            "question": "Who painted the Mona Lisa?",
            "options": [
                "Vincent van Gogh",
                "Pablo Picasso",
                "Leonardo da Vinci",
                "Michelangelo"
            ],
            "correct_answer": [3],
            "explanation": "The Mona Lisa was painted by Leonardo da Vinci during the Italian Renaissance."
        },
        {
            "id": 8,
            "question": "What is the smallest unit of matter?",
            "options": [
                "Molecule",
                "Atom",
                "Proton",
                "Electron"
            ],
            "correct_answer": [2],
            "explanation": "An atom is the smallest unit of matter that retains the properties of an element."
        },
        {
            "id": 9,
            "question": "Which country has the most natural lakes?",
            "options": [
                "United States",
                "Russia",
                "Canada",
                "Finland"
            ],
            "correct_answer": [3],
            "explanation": "Canada has the most natural lakes of any country, with over 2 million lakes."
        },
        {
            "id": 10,
            "question": "What is the hardest natural substance on Earth?",
            "options": [
                "Gold",
                "Iron",
                "Diamond",
                "Quartz"
            ],
            "correct_answer": [3],
            "explanation": "Diamond is the hardest natural substance, ranking 10 on the Mohs hardness scale."
        }
    ]
}

const mockQuizHistory = {
    "mhc-001": [
        {
            quizId: "quiz-mhc-001-01",
            topicId: "mhc-001-01",
            title: "What is Anxiety?",
            correct: 8,
            incorrect: 2,
            partial: 0,
            score: 80,
            totalQuestions: 10,
            status: "Passed",
            completedAt: "2024-01-15T10:30:00Z",
            attemptNumber: 1
        },
        {
            quizId: "quiz-mhc-001-02",
            topicId: "mhc-001-02",
            title: "Stress Management",
            correct: 10,
            incorrect: 1,
            partial: 1,
            score: 88,
            totalQuestions: 12,
            status: "Passed",
            completedAt: "2024-01-16T14:45:00Z",
            attemptNumber: 2
        },
        {
            quizId: "quiz-mhc-001-03",
            topicId: "mhc-001-03",
            title: "Coping Techniques",
            correct: 6,
            incorrect: 2,
            partial: 0,
            score: 75,
            totalQuestions: 8,
            status: "Passed",
            completedAt: "2024-01-17T09:20:00Z",
            attemptNumber: 1
        }
    ],
    "mhc-002": [
        {
            quizId: "quiz-mhc-002-01",
            topicId: "mhc-002-01",
            title: "Introduction",
            correct: 6,
            incorrect: 2,
            partial: 0,
            score: 75,
            totalQuestions: 8,
            status: "Passed",
            completedAt: "2024-01-18T11:15:00Z",
            attemptNumber: 1
        },
        {
            quizId: "quiz-mhc-002-02",
            topicId: "mhc-002-02",
            title: "Recognizing Symptoms",
            correct: 5,
            incorrect: 4,
            partial: 0,
            score: 56,
            totalQuestions: 9,
            status: "Failed",
            completedAt: "2024-01-19T16:30:00Z",
            attemptNumber: 3
        }
    ],
    "mhc-003": [
        {
            quizId: "quiz-mhc-003-01",
            topicId: "mhc-003-01",
            title: "Basics of Mindfulness",
            correct: 5,
            incorrect: 1,
            partial: 0,
            score: 83,
            totalQuestions: 6,
            status: "Passed",
            completedAt: "2024-01-20T08:45:00Z",
            attemptNumber: 1
        },
        {
            quizId: "quiz-mhc-003-02",
            topicId: "mhc-003-02",
            title: "Breathing Techniques",
            correct: 7,
            incorrect: 1,
            partial: 0,
            score: 88,
            totalQuestions: 8,
            status: "Passed",
            completedAt: "2024-01-21T13:20:00Z",
            attemptNumber: 1
        },
        {
            quizId: "quiz-mhc-003-03",
            topicId: "mhc-003-03",
            title: "Body Scan Meditation",
            correct: 6,
            incorrect: 2,
            partial: 1,
            score: 72,
            totalQuestions: 9,
            status: "Passed",
            completedAt: "2024-01-22T15:10:00Z",
            attemptNumber: 2
        }
    ]
};

export const mockQuizApi = {
    async getQuiz(courseId, quizId) {
        // For now, always return the mockQuiz regardless of id
        return simulateAsync({
            ...mockQuiz,
            id: quizId,
            courseId,
            questions: mockQuiz.questions.map((q, i) => ({ ...q, id: i + 1 }))
        });
    },
    async submitQuiz(courseId, quizId, answers) {
        // Just simulate a delay for now
        return simulateAsync({ success: true, courseId, quizId, answers });
    },
    async getQuizHistory(courseId) {
        // Robust lookup: trim, lowercase, match ignoring case
        if (!courseId) {
            return simulateAsync([]);
        }
        const keys = Object.keys(mockQuizHistory);
        // Try exact match first
        if (mockQuizHistory[courseId]) return simulateAsync(mockQuizHistory[courseId]);
        // Try case-insensitive/trimmed match
        const foundKey = keys.find(
            k => k.trim().toLowerCase() === courseId.trim().toLowerCase()
        );
        if (foundKey) {
            return simulateAsync(mockQuizHistory[foundKey]);
        }
        return simulateAsync([]);
    },

    // Save or update a quiz
    async saveQuiz(topicId, quizData) {
        try {
            // In a real app, this would be an API call
            await new Promise(resolve => setTimeout(resolve, 300));

            // Store the quiz data
            quizData[topicId] = {
                ...quizData,
                lastUpdated: new Date().toISOString()
            };

            return {
                success: true,
                data: quizData[topicId]
            };
        } catch (error) {
            console.error('Error saving quiz:', error);
            return {
                success: false,
                error: 'Failed to save quiz'
            };
        }
    },

    // Get a quiz by topic ID
    async getQuiz(topicId) {
        try {
            // Simulate network delay
            await new Promise(resolve => setTimeout(resolve, 300));

            const quiz = quizData[topicId];

            return {
                success: true,
                data: quiz || null
            };
        } catch (error) {
            console.error('Error getting quiz:', error);
            return {
                success: false,
                error: 'Failed to get quiz'
            };
        }
    },

    // Delete a quiz
    async deleteQuiz(topicId) {
        try {
            // Simulate network delay
            await new Promise(resolve => setTimeout(resolve, 300));

            if (quizData[topicId]) {
                delete quizData[topicId];
                return { success: true };
            }

            return {
                success: false,
                error: 'Quiz not found'
            };
        } catch (error) {
            console.error('Error deleting quiz:', error);
            return {
                success: false,
                error: 'Failed to delete quiz'
            };
        }
    },

    // Get quiz history for a course
    async getQuizHistory(courseId) {
        try {
            // Simulate network delay
            await new Promise(resolve => setTimeout(resolve, 500));

            // In a real app, this would filter quizzes by courseId
            const history = Object.values(quizData)
                .filter(quiz => quiz.courseId === courseId)
                .map(quiz => ({
                    id: quiz.id,
                    title: quiz.title,
                    completedAt: new Date().toISOString(),
                    score: Math.floor(Math.random() * 100),
                    totalQuestions: quiz.questions?.length || 0
                }));

            return {
                success: true,
                data: history
            };
        } catch (error) {
            console.error('Error getting quiz history:', error);
            return {
                success: false,
                error: 'Failed to get quiz history'
            };
        }
    }

};
